export default "__VITE_ASSET__60bcbacf__"